<ng-container [formGroup]="parent">
	<table
		mat-table
		class="list-container mb-3"
		[dataSource]="dataSource"
		matSort
		matSortActive="{{ sort.active }}"
		matSortDisableClear
		formArrayName="array"
		matSortDirection="{{ sort.direction }}"
	>
		<ng-container matColumnDef="empty">
			<th mat-header-cell *matHeaderCellDef class="text-center">
				<em>No associated field workers</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
			<td mat-cell *matCellDef="let fieldWorker">
				{{ fieldWorker.name }}
			</td>
		</ng-container>

		<ng-container matColumnDef="employeeCode">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				Employee Code
			</th>
			<td mat-cell *matCellDef="let fieldWorker">
				{{ fieldWorker.employeeCode }}
			</td>
		</ng-container>

		<ng-container matColumnDef="edit">
			<th mat-header-cell *matHeaderCellDef>Edit</th>
			<td mat-cell *matCellDef="let fieldWorker; let i = index">
				<button
					type="button"
					mat-icon-button
					(click)="editFieldWorker(fieldWorker)"
					color="primary"
				>
					<mat-icon>edit</mat-icon>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef>Delete</th>
			<td mat-cell *matCellDef="let fieldWorker; let i = index">
				<button
					type="button"
					mat-icon-button
					color="warn"
					rpsharedConfirm="Remove?"
					(onConfirmed)="array.removeAt(findFieldWorkerLinkIndex(fieldWorker))"
				>
					<mat-icon>delete</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr
			mat-header-row
			*matHeaderRowDef="resultColumns"
			[class.hidden]="dataSource.data?.length < 1"
		></tr>
		<tr
			mat-header-row
			*matHeaderRowDef="emptyColumns"
			[class.hidden]="dataSource.data?.length > 0"
		></tr>
		<tr
			mat-row
			*matRowDef="let fieldWorker; columns: resultColumns"
			[@animateList]
		></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator
			class.hidden="true"
			pageSize="5"
			[pageSizeOptions]="[5, 10]"
		></mat-paginator>
		<button
			type="button"
			class="mr-4"
			(click)="addFieldWorker()"
			mat-mini-fab
			color="primary"
			matTooltip="Add Field Worker"
		>
			<mat-icon>add</mat-icon>
		</button>
	</div>
</ng-container>
